<template>
    <div>
        <el-dialog title="订单历史操作记录" :visible.sync="visible" width="600px" @close="close" center
            :close-on-click-modal="false">
            <h3>
                生产总时长/h：{{ productionTime }}<br>
            </h3>
            <br>
            <el-table :data="tableData" border stripe>
                <el-table-column prop="operationTime" label="操作时间"></el-table-column>
                <el-table-column prop="operator" label="操作人"></el-table-column>
                <el-table-column prop="statusName" label="操作状态"></el-table-column>
            </el-table>

            <span slot="footer">
                <el-button @click="close">关闭</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: 'OrderOperatorHistory',
    props: {
        visible: {
            type: Boolean,
            default: () => { return false }
        },
        order: {
            type: Object,
            default: () => { return {} }
        }
    },
    data() {
        return {
            tableData: [],
            productionTime: '--'
        }
    },
    methods: {
        // 根据工单号获取历史操作记录
        getOrderOperatorHistory() {
            this.$RequestUtil.get({
                url: "/api/productionTask/status-history",
                params: {
                    productionBatchCode: this.order.productionBatchCode
                },
                success: res => {
                    if (res.code == 0) {
                        this.tableData = res.data.itemVOList;
                        this.productionTime = res.data.productionTime ? res.data.productionTime : '--';
                    } else {
                        this.$message.error(res.message);
                    }
                }
            })
        },
        close() {
            this.$emit("update:visible", false)
        }
    },
    watch: {
        visible(newValue, oldValue) {
            if (newValue) {
                this.getOrderOperatorHistory()
            }
        }
    },

}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/order/ProductionTask/OrderOperatorHistory.vue